import Moment from 'moment'
import React, { Component } from 'react'
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import { API_URL } from '../../apiConfig'
import EPanel from '../../elements/components/panel'
import UserContext from '../../UserContext'
import DefaultLayout from './layouts/Default'
import OverviewDetail from './partials/OverviewDetail'
import OverviewFilter from './partials/OverviewFilter'
import OverviewTable from './partials/OverviewTable'
import AuditTable from './partials/AuditTable'

class Overview extends Component {

    static contextType = UserContext;
    intervalID;

    constructor(props) {
        super(props)
        this.handlePageChange = this.handlePageChange.bind(this)
        this.handleFilterChange = this.handleFilterChange.bind(this)
        this.handleFilterAPIChange = this.handleFilterAPIChange.bind(this)
        this.loadData = this.loadData.bind(this)
        this.logout = this.logout.bind(this)
        this.confirm = this.confirm.bind(this)
        this.revert = this.revert.bind(this)
        this.audit = this.audit.bind(this)

        this.state = {
            page: 1,
            perPage: 20,
            items: [],
            audit: [],
            tab: 'all',
            lastRefresh: "",
            printContext: false,
            filters: {
                CISLOZAKAZKY: '',
                PRIJMENI: '',
                LAKOVNA_TYP_MATERIALU_ID: null,
                LAKOVNA_AKCE_ID: null,
            },
            filtersAPI: {
                type: 1, //typ zobrazení
                term: [Moment().startOf('week').isoWeekday(0).add(8, 'days').toDate(), Moment().endOf('week').isoWeekday(0).add(7, 'days').toDate()]
            },
            modals: {
                edit: false,
                revert: false,
                confirm: false,
                audit: false
            },
            itemToEdit: {},
        }
    }

    componentDidMount() {
        const parent = window.parent; // eslint-disable-line no-restricted-globals
        if (parent.setDemoFrameHeight) {
            parent.setDemoFrameHeight();
        }

        // check Auth
        const { user } = this.context;
        if (user.loggedIn) {
            this.loadData();
            this.loadLookups();
        }
        else
            this.logout();
    }

    componentWillUnmount() {
        if (this.intervalID)
            clearInterval(this.intervalID);
    }

    shouldComponentUpdate(nextProps, nextState) {

        // check Auth
        const { user } = this.context;
        if (!user.loggedIn) {
            return false;
        }

        return true;
    }

    // změna stránky
    handlePageChange(page, perPage) {
        if (page !== this.state.page || perPage !== this.state.perPage) {
            this.setState({
                page,
                perPage
            })
        }
    }

    // změna filtru
    handleFilterChange(filter, value) {
        const filterName = String(filter)

        if (this.state.filters.hasOwnProperty(filterName) && value !== this.state.filters[filterName]) {
            this.setState({
                filters: Object.assign({}, this.state.filters, {
                    [filterName]: value
                })
            })
        }
    }

    // změna filtru do API
    handleFilterAPIChange(filter, value) {

        const oldValue = Object.assign(this.state.filtersAPI);

        const filterName = String(filter)

        if (this.state.filtersAPI.hasOwnProperty(filterName) && value !== this.state.filtersAPI[filterName]) {
            this.setState({
                filtersAPI: Object.assign({}, this.state.filtersAPI, {
                    [filterName]: value
                })
            }, () => {
                if (oldValue.type !== this.state.filtersAPI.type || oldValue.term[0] !== this.state.filtersAPI.term[0] || oldValue.term[1] !== this.state.filtersAPI.term[1]) {
                    this.loadData();
                }
            });
        }
    }

    logout() {
        // cookie session je na serveru — jen zahodit lokální stav appky nestačí,
        // jinak cookie zůstane platná až do vypršení (na rozdíl od starého JWT,
        // který se prostě přestal posílat).
        fetch(`${API_URL}/api/auth/logout`, { method: 'POST', credentials: 'include' })
            .catch(() => { /* odhlášení z appky proběhne tak jako tak */ })
            .then(() => {
                const { setUser } = this.context;
                setUser({ loggedIn: false }, () => {
                    this.props.history.push('/login');
                });
            });
    }

    loadData() {

        var start = "";
        var end = "";
        if (this.state.filtersAPI.type === 2 || this.state.filtersAPI.type === 3) {
            start = "&start=" + Moment(this.state.filtersAPI.term[0]).format("YYYY-MM-DD");
            end = this.state.filtersAPI.term[1] ? "&end=" + Moment(this.state.filtersAPI.term[1]).format("YYYY-MM-DD") : "";
        }

        const { user } = this.context;
        if (!user.loggedIn)
            this.props.history.push('/login');

        var fetchProps = {
            link: (this.state.filtersAPI.type === 2 || this.state.filtersAPI.type === 3)
                ? `${API_URL}/api/ZAKAZKA_LAKOVNA_TERMIN?typZobrazeni=` + this.state.filtersAPI.type.toString() + start + end
                : `${API_URL}/api/ZAKAZKA_LAKOVNA_TERMIN?typZobrazeni=` + this.state.filtersAPI.type.toString(),
            method: "GET",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        fetch(fetchProps.link, {
            "method": fetchProps.method,
            "headers": fetchProps.headers,
            "credentials": "include"
        })
            .then(response => {
                if (response.status === 401) {
                    this.props.history.push('/login');
                }
                else {
                    return response.json();
                }
            })
            .then(response => {
                this.setState({
                    items: response,
                    lastRefresh: Moment().format("HH:mm")
                })

                if (this.intervalID)
                    clearInterval(this.intervalID);
                this.intervalID = setInterval(this.loadData.bind(this), 300000);
            })
            .catch(err => {
                console.error("load-data", err);
            });
    }

    postConfirm(item) {

        const requestOptions = {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };

        fetch(`${API_URL}/api/ZAKAZKA_LAKOVNA_TERMIN?id=` + item.ZAKAZKA_LAKOVNA_TERMIN_ID + (item.MANDANT_ID ? "&mandantID=" + item.MANDANT_ID.toString() : ""), requestOptions)
            .then(response => response.json())
            .then(response => {
                if (response.Success) {
                    this.toggleModal('confirm', false)
                    this.loadData();
                }
                else {
                    console.error(response);

                    if (this.state.modals.confirm)
                        this.setState({
                            itemToEdit: Object.assign({}, item, { ErrorMessage: response.Message })
                        })
                }
            })
            .catch(err => {
                console.error(err);

                if (this.state.modals.confirm)
                    this.setState({
                        itemToEdit: Object.assign({}, item, { ErrorMessage: err.message })
                    })
            });
    }

    postRevert(item) {

        const requestOptions = {
            method: 'PUT',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };

        fetch(`${API_URL}/api/ZAKAZKA_LAKOVNA_TERMIN?id=` + item.ZAKAZKA_LAKOVNA_TERMIN_ID, requestOptions)
            .then(response => response.json())
            .then(response => {
                if (response.Success) {
                    this.toggleModal('revert', false)
                    this.loadData();
                }
                else {
                    console.error(response);

                    if (this.state.modals.revert)
                        this.setState({
                            itemToEdit: Object.assign({}, item, { ErrorMessage: response.Message })
                        })
                }
            })
            .catch(err => {
                console.error(err);

                if (this.state.modals.revert)
                    this.setState({
                        itemToEdit: Object.assign({}, item, { ErrorMessage: err.message })
                    })
            });
    }

    confirm(item) {
        this.setState({
            itemToEdit: Object.assign({}, item)
        })
        this.toggleModal('confirm', true)
    }

    revert(item) {
        this.setState({
            itemToEdit: Object.assign({}, item)
        })
        this.toggleModal('revert', true)
    }

    audit(item) {
        this.setState({
            itemToEdit: Object.assign({}, item)
        })

        var fetchProps = {
            link: `${API_URL}/api/ZAKAZKA_LAKOVNA_TERMIN_AUDIT?id=` + item.ZAKAZKA_ID.toString(),
            method: "GET",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        fetch(fetchProps.link, {
            "method": fetchProps.method,
            "headers": fetchProps.headers,
            "credentials": "include"
        })
            .then(response => response.json())
            .then(response => {

                this.setState({
                    audit: response
                })

                this.toggleModal('audit', true)
            })
            .catch(err => {
                console.error("load-data", err);
            });
    }

    loadLookups() {

        const { user } = this.context;

        // RLAKOVNA_AKCE
        var fetchPropsActions = {
            link: `${API_URL}/api/RLAKOVNA_AKCE`,
            method: "GET",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        fetch(fetchPropsActions.link, {
            "method": fetchPropsActions.method,
            "headers": fetchPropsActions.headers,
            "credentials": "include"
        })
            .then(response => response.json())
            .then(response => {
                this.setState({
                    actions: response
                })
            })
            .catch(err => {
                console.log(err);
            });

        // RLAKOVNA_TYP_MATERIALU
        var fetchPropsMaterials = {
            link: `${API_URL}/api/RLAKOVNA_TYP_MATERIALU`,
            method: "GET",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        fetch(fetchPropsMaterials.link, {
            "method": fetchPropsMaterials.method,
            "headers": fetchPropsMaterials.headers,
            "credentials": "include"
        })
            .then(response => response.json())
            .then(response => {
                this.setState({
                    materials: response
                })
            })
            .catch(err => {
                console.log(err);
            });



        // CMANDANT
        if (user.loggedIn) {
            var fetchPropsMandants = {
                link: `${API_URL}/api/CMANDANT?roleID=24`,
                method: "GET",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            };

            fetch(fetchPropsMandants.link, {
                "method": fetchPropsMandants.method,
                "headers": fetchPropsMandants.headers,
                "credentials": "include"
            })
                .then(response => response.json())
                .then(response => {
                    this.setState({
                        mandants: response
                    })
                })
                .catch(err => {
                    console.log(err);
                });
        }

    }


    toggleModal(modal, show) {
        if (this.state.modals.hasOwnProperty(modal)) {
            this.setState({
                modals: Object.assign({}, this.state.modals, { [modal]: show !== undefined ? show : !this.state.modals[modal] })
            })
        }
    }

    onPrint() {
        var oldState = Object.assign({}, this.state);

        this.setState({
            printContext: true,
            page: 1
        }, () => {

            window.print();

            this.setState({
                printContext: false,
                page: oldState.page
            })
        });

    }

    render() {

        const tabs = function () {

            let all = this.state.items.slice();

            if (this.state.filters.PRIJMENI) {
                all = searchArray(all, this.state.filters.PRIJMENI, ['PRIJMENI'])
            }

            if (this.state.filters.CISLOZAKAZKY) {
                all = searchArray(all, this.state.filters.CISLOZAKAZKY, ['CISLOZAKAZKY'])
            }

            if (this.state.filters.LAKOVNA_TYP_MATERIALU_ID !== null) {
                all = all.filter(i => i.LAKOVNA_TYP_MATERIALU_ID === this.state.filters.LAKOVNA_TYP_MATERIALU_ID)
            }

            if (this.state.filters.LAKOVNA_AKCE_ID !== null) {
                all = all.filter(i => i.LAKOVNA_AKCE_ID === this.state.filters.LAKOVNA_AKCE_ID)
            }

            return {
                all
            }
        }.bind(this)()

        //const getMinHeight = function () {
        //    return (window.innerHeight - 50) + "px";
        //}
        // style={{ minHeight: getMinHeight() }}

        const { user } = this.context;

        return (
            <DefaultLayout>
                <div className="row flex-lg-nowrap">
                    <div className="col mb-3">

                        <EPanel
                            titleNode={
                                <h5>
                                    <i className="fa fa-paint-brush"></i> Lakovna
                                    <small> seznam práce <sup hidden={tabs[this.state.tab].length === 0}>{tabs[this.state.tab].length.toString()}</sup></small>
                                    <small><b>{(this.state.filters.PRIJMENI ? " [název='" + this.state.filters.PRIJMENI + "']" : null)}</b></small>
                                    <small><b>{(this.state.filters.CISLOZAKAZKY ? " [zakázka=" + this.state.filters.CISLOZAKAZKY + "]" : null)}</b></small>
                                    <small><b>{(this.state.filters.LAKOVNA_TYP_MATERIALU_ID ? " [materiál='" + this.state.materials.filter(x => x.LAKOVNA_TYP_MATERIALU_ID === this.state.filters.LAKOVNA_TYP_MATERIALU_ID)[0].POPIS + "']" : null)}</b></small>
                                    <small><b>{(this.state.filters.LAKOVNA_AKCE_ID ? " [akce='" + this.state.actions.filter(x => x.LAKOVNA_AKCE_ID === this.state.filters.LAKOVNA_AKCE_ID)[0].POPIS + "']" : null)}</b></small>
                                </h5>
                            }
                            actionsNode={
                                <button className="btn btn-sm btn-link noprint" onClick={() => this.onPrint()} style={{ paddingBottom: "0rem", paddingTop: "0rem" }}>
                                    <i className="fa fa-print"></i>&nbsp;tisk
                                </button>
                            }
                        >
                            {(this.state.printContext) ?
                                <OverviewTable key={ "noPages" }
                                    items={tabs[this.state.tab]}
                                    type={this.state.filtersAPI.type}
                                />
                                :
                                <OverviewTable key={"pages"}
                                    items={tabs[this.state.tab]}
                                    type={this.state.filtersAPI.type}
                                    page={this.state.page}
                                    perPage={this.state.perPage}
                                    onPageChange={this.handlePageChange}
                                    onConfirm={this.confirm}
                                    onRevert={this.revert}
                                    onAudit={this.audit }

                                    selected={tabs['selected']}
                                    onSelect={this.handleSelect}
                                    onSelectAll={this.handleSelectAll}
                                />
                           }
                        </EPanel>

                        <Modal
                            key={ "action" }
                            isOpen={(this.state.modals.confirm || this.state.modals.revert)}
                            toggle={() => {
                                if (this.state.modals.confirm)
                                    this.toggleModal('confirm');
                                else if (this.state.modals.revert)
                                    this.toggleModal('revert');
                            }}
                            size="lg"
                            backdrop="static"
                            fade={false}
                            keyboard={true}>
                            <ModalHeader >
                                <span style={{ fontWeight: '600', fontSize: '1.5rem' }}><i className="fa fa-paint-brush"></i> Akce lakovny</span>
                            </ModalHeader>

                            <ModalBody>
                                <div className="py-1">
                                    <OverviewDetail
                                        item={this.state.itemToEdit}
                                        mandants={this.state.mandants}
                                        modals={this.state.modals}
                                    />
                                </div>
                            </ModalBody>

                            <ModalFooter>
                                <div className="col-md-6 text-muted text-left">
                                    <small>{user.fullName} ({user.type})</small>
                                </div>

                                <div className="col-md-6 text-right">

                                    {(!this.state.itemToEdit.ErrorMessage && this.state.modals.confirm) ?
                                        <button key={"confirm"}
                                            name="confirm"
                                            className="btn btn-primary"
                                            type="button"
                                            onClick={() => this.postConfirm(this.state.itemToEdit)}>
                                            Potvrdit akci
                                        </button>
                                        : null}
                                    {(!this.state.itemToEdit.ErrorMessage && this.state.modals.revert) ?
                                        <button key={"revert"}
                                            name="revert"
                                            className="btn btn-danger"
                                            type="button"
                                            onClick={() => this.postRevert(this.state.itemToEdit)}>
                                            Vrátit zpět na předchozí akci
                                        </button>
                                        : null}
                                    <span hidden={this.state.itemToEdit.ErrorMessage}>&nbsp;&nbsp;</span>

                                    <button
                                        autoFocus
                                        name="close"
                                        className="btn btn-warning "
                                        type="button"
                                        onClick={() => {
                                            if (this.state.modals.confirm)
                                                this.toggleModal('confirm');
                                            else if (this.state.modals.revert)
                                                this.toggleModal('revert');
                                        }}>
                                        Zavřít
                                    </button>

                                </div>
                            </ModalFooter>
                        </Modal>

                        <Modal
                            key={"audit"}
                            isOpen={(this.state.modals.audit)}
                            toggle={() => { this.toggleModal('audit'); }}
                            size="lg"
                            backdrop="static"
                            fade={false}
                            keyboard={true}>
                            <ModalHeader >
                                <span style={{ fontWeight: '600', fontSize: '1.5rem' }}>Audit {this.state.itemToEdit.CISLOZAKAZKY} {this.state.itemToEdit.PRIJMENI}</span>
                            </ModalHeader>

                            <ModalBody>
                                <div className="py-1">
                                    <AuditTable items={this.state.audit}/>
                                </div>
                            </ModalBody>

                            <ModalFooter>
                                <div className="col-md-6 text-muted text-left">
                                    <small>{user.fullName} ({user.type})</small>
                                </div>

                                <div className="col-md-6 text-right">
                                    <button
                                        autoFocus
                                        name="close"
                                        className="btn btn-warning "
                                        type="button"
                                        onClick={() => { this.toggleModal('audit'); }}>
                                        Zavřít
                                    </button>

                                </div>
                            </ModalFooter>
                        </Modal>

                    </div>

                    <div className="col-12 col-lg-3 mb-3 noprint">
                        <OverviewFilter
                            items={this.state.rows}
                            materials={this.state.materials}
                            actions={this.state.actions}

                            filters={this.state.filters}
                            filtersAPI={this.state.filtersAPI}
                            tabs={tabs}
                            tab={this.state.tab}
                            lastRefresh={this.state.lastRefresh}
                            userName={user.fullName}
                            onFilterChange={this.handleFilterChange}
                            onFilterAPIChange={this.handleFilterAPIChange}
                            onClickLoadData={this.loadData}
                            onClickLogout={this.logout}
                        />

                    </div>
                </div>
            </DefaultLayout>
        )
    }
}

function searchArray(array, query, fields = []) {
    if (!array.length || !String(query)) {
        return array
    }

    return array.filter(item => {
        let found = false;
        for (let key in item) {
            if (fields.length && fields.indexOf(key) < 0) {
                continue
            }
            if (typeof item[key] === 'string' &&
                item[key].toLowerCase().indexOf(query.toLowerCase()) >= 0) {
                found = true;
            }
        }
        return found;
    })
}

export default Overview


